import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Menu } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "./../styles/colors";
import Images from "../assets/Images";
import Navigation from "./../Navigation";

const drawerWidth = 270;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(1, 0, 0, 1),
  margin: "10px",
  ...theme.mixins.toolbar,
}));

const SideNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  const drawerContent = (
    <Box>
      <DrawerHeader>
        <img src={Images.logo} alt="Takseem" width="70%" />
      </DrawerHeader>

      <List>
        {Navigation.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              selected={pathname === item.path || pathname === item.subPath}
              onClick={() => {
                navigate(item.path);
                if (isMobile) setMobileOpen(false); // close drawer on mobile click
              }}
              sx={{
                borderRadius: 2,
                mx: 1,
                mt: 1.5,
                "&.Mui-selected": {
                  backgroundImage: colors.primaryGradient,
                  bgcolor: colors.primary,
                  color: colors.white,
                  ":hover": {
                    backgroundColor: colors.primary,
                    color: colors.white,
                  },
                },
                ":hover": {
                  backgroundColor: colors.primary,
                  color: colors.white,
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 3,
                  justifyContent: "center",
                  bgcolor: colors.white,
                  borderRadius: "6px",
                }}
              >
                {item.icon}
              </ListItemIcon>

              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontSize: "0.95rem",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* Hamburger Button for Mobile */}
      {isMobile && (
        <Box
          sx={{
            position: "fixed",
            top: 12,
            left: 12,
            zIndex: 1300,
            backgroundColor: colors.primary,
            borderRadius: "10px",
          }}
        >
          <IconButton onClick={handleDrawerToggle} sx={{ color: colors.white }}>
            <Menu />
          </IconButton>
        </Box>
      )}

      {/* Mobile Drawer */}
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            bgcolor: colors.white,
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
              width: 6,
              bgcolor: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: 1,
              bgcolor: colors.primary,
            },
          },
        }}
        anchor="left"
      >
        {drawerContent}
      </Drawer>

      {/* Desktop Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            bgcolor: colors.white,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default SideNav;
